<template>
  <div id="app">
    <!-- 保留主布局及其子页面状态，返回功能首页时不重新挂载、不重复刷新 -->
    <keep-alive include="LayoutPage">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

#app {
  background: #f7f8fa;
}
</style>
